import { getSortablePeriodLabels } from './getSortablePeriodLabels';

/**
 * Returns a string label for a statement period that can be sorted as a string, with the year
 * first and then the quarter. Using the input:
 *      { start_date: '2020-01-01', end_date: '2020-03-31', unit: 'quarter' }
 * would cause the returned value: '2020 Q1'.
 * @param statementPeriod a StatementPeriod
 * @param defaultPeriodLabel a default period label to be used if no sortable label can be found
 */
export const getSortableStatementPeriodLabel = (
    statementPeriod: Maybe<ProStatementPeriod>,
    defaultPeriodLabel: string,
): string => {
    if (statementPeriod === null) {
        return defaultPeriodLabel;
    }

    const periodLabels = getSortablePeriodLabels(statementPeriod);

    return periodLabels.short ?? periodLabels.long ?? defaultPeriodLabel;
};
